function isChildOf(child, parent) {
  let node = child;
  while (node !== null) {
    if (node === parent) return true;
    node = node.parentNode;
  }

  return false;
}

function classOrIdIn(event, arr) {
  return arr
    .filter(str => event.target.parentNode.id.indexOf(str) > -1
    || event.target.parentNode.className.indexOf(str) > -1).length > 0;
}


const Utils = {
  isChildOf,
  classOrIdIn,

};

export default Utils;
